import { split, join, map, capitalize } from "lodash";

const checkSlugForPrefixSlash = slug => {
  if (slug.charAt(0) !== "/") {
    return `/${slug}`;
  }
  return slug;
};

const capitalizeCategoryName = cat => {
  if (cat) {
    const categoryName = Array.isArray(cat) ? cat[0] : cat;
    const splitString = split(categoryName, "-");
    return join(map(splitString, capitalize), " ");
  }
  return null;
};

export { checkSlugForPrefixSlash, capitalizeCategoryName };
